import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/AuthContext";
import { FileText, History as HistoryIcon, Settings as SettingsIcon } from "lucide-react";
import { NAV } from "@/constants/testIds";

/**
 * Fixed bottom tab bar for mobile — gives SUX1 the native-app feel that
 * beta testers asked for. Hidden on md+ (desktop keeps the top header nav).
 * Rendered only when a user is authenticated.
 */
export const MobileTabBar = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  if (!user) return null;

  const tabs = [
    { to: "/", end: true, label: t("nav.summarize"), Icon: FileText, tid: NAV.dashboardLink + "-mobile" },
    { to: "/history", end: false, label: t("nav.history"), Icon: HistoryIcon, tid: NAV.historyLink + "-mobile" },
    { to: "/settings", end: false, label: t("nav.settings"), Icon: SettingsIcon, tid: NAV.settingsLink + "-mobile" },
  ];

  return (
    <nav
      data-testid="mobile-tab-bar"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-border bg-background/95 backdrop-blur-md pb-[env(safe-area-inset-bottom)]"
      role="navigation"
      aria-label="Bottom navigation"
    >
      <ul className="grid grid-cols-3">
        {tabs.map(({ to, end, label, Icon, tid }) => (
          <li key={to} className="border-r border-border last:border-r-0">
            <NavLink
              to={to}
              end={end}
              data-testid={tid}
              className={({ isActive }) =>
                `relative flex flex-col items-center justify-center gap-1 py-2.5 transition-all active:scale-95 ${
                  isActive
                    ? "text-[#002FA7] dark:text-[#4B7BFF] bg-secondary/60"
                    : "text-muted-foreground"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon className={`w-5 h-5 ${isActive ? "" : ""}`} strokeWidth={isActive ? 2.5 : 1.75} />
                  <span
                    className={`font-mono uppercase tracking-[0.1em] text-[9px] ${
                      isActive ? "font-bold" : ""
                    }`}
                  >
                    {label}
                  </span>
                  {isActive && (
                    <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-[#002FA7] dark:bg-[#4B7BFF]" />
                  )}
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default MobileTabBar;
